/**
 * Milotté scroll motion — Phase 4.1
 *
 * Two effects:
 *   1. Fade-in as sections cross 30% into viewport (.js-fade-in → .in-view)
 *   2. Light parallax on hero image when [data-parallax="true"] (0.3 ratio)
 *
 * Respects prefers-reduced-motion: reduce — both effects disabled.
 * No CLS (sections render with content; .in-view just animates opacity).
 */

(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    // Skip all motion. Mark fade-in elements as visible so they don't stay hidden.
    document.querySelectorAll('.js-fade-in').forEach(function (el) {
      el.classList.add('in-view');
    });
    return;
  }

  // ---- 1. Fade-in observer ----
  if ('IntersectionObserver' in window) {
    const fadeInObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            fadeInObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -5% 0px' }
    );

    function observeFadeTargets() {
      document.querySelectorAll('.js-fade-in:not(.in-view)').forEach(function (el) {
        fadeInObserver.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeFadeTargets);
    } else {
      observeFadeTargets();
    }
  } else {
    // No IO support — show all
    document.querySelectorAll('.js-fade-in').forEach(function (el) {
      el.classList.add('in-view');
    });
  }

  // ---- 2. Hero parallax ----
  function initParallax() {
    const heroes = document.querySelectorAll('.hero-editorial[data-parallax="true"]');
    if (!heroes.length) return;

    let ticking = false;

    function update() {
      heroes.forEach(function (hero) {
        const rect = hero.getBoundingClientRect();
        // Only translate when hero is in viewport
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const media = hero.querySelector('.hero-editorial__media');
        if (!media) return;
        // 0.3 ratio: media moves slower than scroll
        const offset = rect.top * -0.3;
        media.style.transform = 'translate3d(0, ' + offset.toFixed(1) + 'px, 0)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
